import { Avatar, Descriptions, Divider, Drawer } from "antd";
import moment from "moment";

function ViewDetail(props: any) {
  let { openViewDetail, setOpenViewDetail, dataViewDetail } =
    props;
  const onClose = () => {
    setOpenViewDetail(false);
  };
  return (
    <>
      <Drawer
        title="Chức năng xem chi tiết"
        width={"50vw"}
        onClose={onClose}
        open={openViewDetail}>
        <Descriptions title="Thông tin người dùng" bordered column={2}>
          <Descriptions.Item label="ID">
            {dataViewDetail?._id}
          </Descriptions.Item>
          <Descriptions.Item label="Họ tên">
            {dataViewDetail?.name}
          </Descriptions.Item>
          <Descriptions.Item label="Email">
            {dataViewDetail?.email}
          </Descriptions.Item>
          <Descriptions.Item label="Giới tính">
            {dataViewDetail?.gender}
          </Descriptions.Item>
          <Descriptions.Item label="Địa chỉ" >
            {dataViewDetail?.address}
          </Descriptions.Item>
          <Descriptions.Item label="Ngày sinh" >
            {dataViewDetail?.date_of_birth}
          </Descriptions.Item>
          <Descriptions.Item label="Ngày tạo">
            {moment(dataViewDetail?.createdAt).format("DD-MM-YY HH:mm:ss")}
          </Descriptions.Item>
          <Descriptions.Item label="Ngày cập nhật">
            {moment(dataViewDetail?.updatedAt).format("DD-MM-YY HH:mm:ss")}
          </Descriptions.Item>
        </Descriptions>

        <Divider orientation="left">Ảnh đại diện</Divider>
        <Avatar shape="square" size={200} src={dataViewDetail?.avatar} />
      </Drawer>
    </>
  );
}

export default ViewDetail;
